<template>
  <BaseCustomizeMetal componentCode="K" />
</template>

<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalK",
  components: {
    BaseCustomizeMetal,
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 137px;
    left: 106px;
    @include betweenTableTablePro {
      top: 90px;
      left: 56px;
    }
    @include table {
      top: 67px;
      left: 33px;
    }
    @include phone {
      top: 56px;
      left: 17px;
    }
  }
  .templeName {
    height: 40px;
    width: 189px;
    margin: 5px auto;
    .textContainer {
      width: 189px;
    }
  }
  .godName {
    width: 283px;
    height: 75px;
    .textContainer {
      width: 283px;
    }
  }
  .gift {
    width: 265px;
    height: 46px;
    margin: 5px auto;
    .textContainer {
      width: 265px;
    }
  }
}
</style>
